<!-- eslint-disable no-unused-vars -->
<template>
  <v-main class="align-center justify-center" style="min-height: 300px">
    <div v-if="loading">Cargando ...</div>
    <div v-else>
      <TaskList2 :jobs="jobs" />
    </div>
  </v-main>
</template>

<script>
import TaskList2 from "./components/task/TaskList2.vue";
import axios from "axios";

export default {
  name: "TaskView2",
  components: {
    TaskList2,
  },
  setup() {
    return {};
  },
  async mounted() {
    const params = {
      "page_size": 100,
      "page": 1,
    }
    const headers = {
      "Content-Type": "application/json",
      "x-auth-token": localStorage.getItem("x-auth-token"),
    }
    const url = "https://wayline.cvis.videri.ai/flight-task/" + localStorage.getItem("device_sn")
    const data = await axios.get(url, {headers, params})
      .then((response) => {
        console.log(response);
        this.jobs = response.data.tasks;
        console.log(this.jobs);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
      console.log(data)
    this.loading = false;
  },
  data: () => ({
    jobs: [],
    loading: true,
  }),
  methods: {
   
  },
  computed: {
    //
  },
  watch: {},
  created() {
    
  },
};
</script>

<style scoped>
.container {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
